import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import api from "api/api";
import { ORDER_PRODUCTS } from "constants/ApiRoutes";
import { useEffect } from "react";

const OrderProductsContext = createContext([]);

const OrderProductsProvider = ({ children }) => {
  const [orderProducts, setOrderProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const addProductsOrder = async (product) => {
    setOrderProducts([...orderProducts, product]);
  };

  const removeFromOrderProducts = (index) => {
    setOrderProducts(orderProducts.filter((_, i) => i !== index));
  };

  const totalPriceRetail = orderProducts.reduce((total, item) => {
    return total + Number(item.priceRetail);
  }, 0);

  const storeOrderProducts = async (orderId, data) => {
    setLoading(true);
    await api
      .post(ORDER_PRODUCTS, {
        order: { id: orderId },
        products: data,
      })
      .then((response) => {
        setMsg(response.data.message);
        setIsOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <OrderProductsContext.Provider
      value={{
        addProductsOrder,
        removeFromOrderProducts,
        totalPriceRetail,
        storeOrderProducts,
        orderProducts,
        setOrderProducts,
        loading,
        msg,
        isOpen,
        setIsOpen,
      }}
    >
      {children}
    </OrderProductsContext.Provider>
  );
};

const useOrderProducts = () => {
  const context = useContext(OrderProductsContext);
  if (!context) {
    throw new Error("useOrderProducts must be used within a OrderProductsProvider");
  }
  return context;
};

export { OrderProductsProvider, useOrderProducts };

OrderProductsProvider.propTypes = {
  children: PropTypes.element,
};
